export const hasTextContent = (html: string | undefined | null): html is string => {
  if (!html) {
    return false
  }

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  const textContent = tempDiv.textContent || tempDiv.innerText || ''

  return textContent.trim().length > 0
}
